import React, { useState, useEffect } from "react";
import { Card, Modal, Button } from "react-bootstrap";

function TableModal(props) {
  useEffect(() => {}, []);

  const [show, setShow] = useState(true);
  const [responseUrl, setResponseUrl] = useState();

  useEffect(() => {
    console.log(props.response)
    setResponseUrl(props.response);
    setShow(true); // Reabrir el modal si `response` cambia
  }, [props.response, props.latlng]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (

    <Modal
      show={show}
      onHide={handleClose}
      centered   
    >
      <Modal.Header closeButton >
        <Modal.Title centered>Información de la Parcela</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          className="mt-4 mb-4 table-responsive text-center "
          style={{
            fontFamily: "Arial, sans-serif",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#f5f5f5",
            borderRadius: "8px",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
          }}
          dangerouslySetInnerHTML={{ __html: responseUrl }}
        />
      </Modal.Body>
      {/* <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handleClose}>
          Save Changes
        </Button>
      </Modal.Footer> */}
    </Modal>
  );
}

export default TableModal;
